import typeCheck from 'common/util/typeCheck';

import { SR_API_ACTION_PARTNER_GET_LISTING_STRIPE_ACCOUNT } from 'api/actionTypes';

export default async function loadListingStripeAccount(
  { state, apiClient },
  { listingId, forceRefresh = false },
) {
  typeCheck('listingId::PositiveNumber', listingId);
  const statePath = ['listingStripeAccountsByListingId', listingId];
  if (state.exists(statePath) && !forceRefresh) {
    return state.get(statePath);
  }
  return apiClient.postWithState({
    action: SR_API_ACTION_PARTNER_GET_LISTING_STRIPE_ACCOUNT,
    queryId: listingId,
    state: state,
    payload: {
      listingId,
    },
    onSuccess(stripeAccount) {
      state.set(statePath, stripeAccount);
    },
  });
}
